import { useRef, useState } from "react";
import { toPng } from "html-to-image";
import { Instagram, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { IG_HANDLE } from "@/lib/brand";
import { StoryCard } from "./StoryCard";

export const StoryShareButton = ({ plan }) => {
  const ref = useRef(null);
  const [busy, setBusy] = useState(false);

  const download = async () => {
    setBusy(true);
    try {
      const url = await toPng(ref.current, { width: 1080, height: 1920, pixelRatio: 1, cacheBust: true });
      const a = document.createElement("a");
      a.href = url;
      a.download = `${plan.request.business_name.replace(/\W+/g, "-")}-content-calendar-story.png`;
      a.click();
      toast.success(`Downloaded! Post it to your Story and tag ${IG_HANDLE}`);
    } catch {
      toast.error("Couldn't create the image, please try again");
    }
    setBusy(false);
  };

  return (
    <>
      <button onClick={download} disabled={busy} data-testid="story-share-btn"
        className="no-print self-start rounded-full bg-[var(--gold)] text-[var(--green)] px-5 py-2.5 font-bold flex items-center gap-2 hover:scale-[1.04] transition-transform disabled:opacity-70">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Instagram size={16} />} Download Story image
      </button>
      <div aria-hidden="true" style={{ position: "fixed", left: -10000, top: 0, pointerEvents: "none" }}>
        <StoryCard ref={ref} plan={plan} />
      </div>
    </>
  );
};
